module.exports = __webpack_public_path__ + "media/images/social-icons/facebook-b844c6116657de68e001318f2b82f8cc.svg";